import { SubMenu } from "react-pro-sidebar";
import { Box, Button, useTheme } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import Item from "../item";
import { tokens } from "../../../theme";

const Practice503a = ({
  lookupcodetype, title, a503Operations, tempDummyOperation,
  inspectionUid, selected, setSelected, colors }) => {

  const theme = useTheme();
  const themeColors = tokens(theme.palette.mode);
  const navigate = useNavigate();

  return (
    <SubMenu
      key={lookupcodetype}
      title={title}
      style={{
        color: colors.grey[100],
      }}
    >
      {/* Add New Button */}
      <Box sx={{ padding: "8px 20px" }}>
        <Button
          variant="outlined"
          size="small"
          startIcon={<AddIcon />}
          onClick={() => {
            setSelected("Add New 503A Operation");

            const dummyOperation = {
              inspection_503a_operation_uid: 'temp-new-503a-operation',
              code: 'Creating...',
              description: 'New 503A Operation (Creating...)',
              isTemporary: true
            };

            window.dispatchEvent(new CustomEvent('503aDummyItemCreated', {
              detail: { dummyOperation }
            }));

            navigate(`/inspection/${inspectionUid}/503a/new`);
          }}
          sx={{
            color: themeColors.greenAccent[400],
            borderColor: themeColors.greenAccent[400],
            "&:hover": {
              borderColor: themeColors.greenAccent[300],
              backgroundColor: themeColors.greenAccent[900],
            },
            fontSize: "0.75rem",
            width: "100%"
          }}
        >
          Add New
        </Button>
      </Box>

      {/* Dummy Operation (if creating) */}
      {tempDummyOperation && (
        <Item
          key={tempDummyOperation.inspection_503a_operation_uid}
          title={tempDummyOperation.description}
          to={null}
          selected={selected}
          setSelected={setSelected}
          style={{
            opacity: 0.7,
            fontStyle: 'italic',
            pointerEvents: 'none',
            color: '#999'
          }}
        />
      )}

      {/* Existing 503A Operations */}
      {a503Operations?.map((operation) => {
        const operationId = operation.inspection_503a_operation_uid || operation.inspection_detail_uid;
        const displayTitle = operation.description || operation.code;
        return (
          <Item
            key={operationId}
            title={displayTitle}
            to={`/inspection/${inspectionUid}/503a/${operationId}`}
            selected={selected}
            setSelected={setSelected}
          />
        );
      })}
    </SubMenu>
  );
};

export default Practice503a;
